import initVueApp from "@/core.js";
const component = require(`../views/RecursiveJSONTemplate.vue`).default;
require("@/myfont.font.js");
initVueApp(component);
